import React, { useState, useEffect } from 'react';
import './App.css';
import GameBoard from './components/GameBoard';
import ScoreBoard from './components/ScoreBoard';
import Timer from './components/Timer';
import GameOver from './components/GameOver';
import StartScreen from './components/StartScreen';
import MobileOptimization from './components/MobileOptimization';
import { loadFromLocalStorage, saveToLocalStorage, isMobileDevice } from './utils/gameUtils';

function App() {
  const [gameState, setGameState] = useState('start'); // start, playing, gameOver
  const [score, setScore] = useState(0);
  const [highScore, setHighScore] = useState(0);
  const [timeLeft, setTimeLeft] = useState(60); // 60초 제한 시간
  const [gameMode, setGameMode] = useState('arcade'); // arcade, challenge, zen
  const [isMobile, setIsMobile] = useState(false);

  // 모바일 디바이스 감지
  useEffect(() => {
    setIsMobile(isMobileDevice());
  }, []);

  // 로컬 스토리지에서 최고 점수 불러오기
  useEffect(() => {
    const savedHighScore = loadFromLocalStorage('highScore', 0);
    if (savedHighScore) {
      setHighScore(parseInt(savedHighScore));
    }
  }, []);

  // 최고 점수 저장
  useEffect(() => {
    if (score > highScore) {
      setHighScore(score);
      saveToLocalStorage('highScore', score);
    }
  }, [score, highScore]);

  // 게임 시작
  const startGame = (mode) => {
    setGameMode(mode);
    setScore(0);
    setTimeLeft(mode === 'zen' ? Infinity : 60);
    setGameState('playing');
    
    // 게임 시작 시 화면 방향 고정 (모바일)
    if (isMobile && window.screen && window.screen.orientation) {
      try {
        window.screen.orientation.lock('portrait');
      } catch (error) {
        console.log('화면 방향 고정 실패:', error);
      }
    }
  };

  // 게임 종료
  const endGame = () => {
    setGameState('gameOver');
    
    // 게임 종료 시 화면 방향 잠금 해제 (모바일)
    if (isMobile && window.screen && window.screen.orientation) {
      try {
        window.screen.orientation.unlock();
      } catch (error) {
        console.log('화면 방향 잠금 해제 실패:', error);
      }
    }
  };

  // 게임 재시작
  const restartGame = () => {
    startGame(gameMode);
  };

  // 메인 메뉴로 돌아가기
  const goToMainMenu = () => {
    setGameState('start');
  };

  // 점수 업데이트
  const updateScore = (points) => {
    setScore(prevScore => prevScore + points);
  };

  return (
    <div className="App">
      {/* 모바일 최적화 컴포넌트 */}
      {isMobile && <MobileOptimization />}
      
      {gameState === 'start' && (
        <StartScreen onStartGame={startGame} />
      )}
      
      {gameState === 'playing' && (
        <>
          <div className="game-header">
            <ScoreBoard score={score} highScore={highScore} />
            {gameMode !== 'zen' && <Timer timeLeft={timeLeft} setTimeLeft={setTimeLeft} onTimeUp={endGame} />}
          </div>
          <GameBoard 
            gameMode={gameMode} 
            updateScore={updateScore} 
            endGame={endGame}
          />
        </>
      )}
      
      {gameState === 'gameOver' && (
        <GameOver 
          score={score} 
          highScore={highScore} 
          onRestart={restartGame} 
          onMainMenu={goToMainMenu} 
        />
      )}
    </div>
  );
}

export default App;
